export const types = {
  APP_IS_MOBILE: 'APP_IS_MOBILE',
}

export const isMobileAction = (isMobileView = false) => {
  return {
    type: types.APP_IS_MOBILE,
    payload: isMobileView,
  }
}
